module.exports = __webpack_public_path__ + "img/ma210.34350876.png";